import { LocationUsageType } from '../..';

export interface ILocation {
  pricingTierMatch?: any;
  id: string;
  name: string;
  countryId: string;
  countryName: string;
  isEntireCountry: boolean;
  distributionBoundary?: IGeography;
  point?: IGeography;
  usageType: LocationUsageType;
  active: boolean;
  openingTime: string;
  closingTime: string;
  notificationEmailAddress: string;
  contactPersonName: string;
  contactPersonNumber: string;
  isHeadOffice: boolean;
  updateCountryByCoordinates?: boolean;
  type?: string;
  address?: ILocationAddress;
}

export interface ILocationAddress {
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  town: string;
  province: string;
  postalCode: string;
  id?: string;
}

export interface IEntityOrderLocationDetails {
  entityId: string;
  location: ILocation;
  orderType: string;
  externalOrderId?: string;
  externalInvoiceId?: string;
}

export interface ILocationSimple {
  id: string;
  name: string;
}

export interface IGeography {
  type: string;
  coordinates: any[]; // [lat,lng]
}
